/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const formInstanceSignatures = sqliteTable('form_instance_signatures', {
  id: text('id').primaryKey().notNull(),
  form_instance_id: text('form_instance_id'),
  field_key: text('field_key'),
  stroke_data: text('stroke_data'),
  image_url: text('image_url'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
